'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MPPHeaderRoot = require('../components/MPPHeaderRoot');

var _MPPHeaderRoot2 = _interopRequireDefault(_MPPHeaderRoot);

var _MPPHeaderDefaultProps = require('../components/MPPHeaderDefaultProps');

var _MPPHeaderDefaultProps2 = _interopRequireDefault(_MPPHeaderDefaultProps);

var _MPPHeaderPropTypes = require('../components/MPPHeaderPropTypes');

var _MPPHeaderPropTypes2 = _interopRequireDefault(_MPPHeaderPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dropdownLinks = [];

var GlobalHeader = function (_Component) {
  _inherits(GlobalHeader, _Component);

  function GlobalHeader(props) {
    _classCallCheck(this, GlobalHeader);

    var _this = _possibleConstructorReturn(this, (GlobalHeader.__proto__ || Object.getPrototypeOf(GlobalHeader)).call(this, props));

    _this.registerDropDown = function (elemRef) {
      return dropdownLinks.push(elemRef) - 1;
    };

    _this.handleMainLinks = _this.handleMainLinks.bind(_this);
    _this.setState = _this.setState.bind(_this);
    _this.openHeader = _this.openHeader.bind(_this);
    _this.closeHeader = _this.closeHeader.bind(_this);
    _this.openSubnav = _this.openSubnav.bind(_this);
    _this.closeSubnav = _this.closeSubnav.bind(_this);
    _this.handleMenuButton = _this.handleMenuButton.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.headerRef = null;
    _this.bodyRef = null;
    _this.bodyClassNameWhenOpen = 'menu-open' + (props.config.rtl ? '-rtl' : '');
    _this.state = {
      isOpen: false,
      isClosing: false,
      activeLink: null,
      closingLinkIndex: -1,
      activeLinkIndex: -1,
      currentWindowWidth: 0
    };
    return _this;
  }

  _createClass(GlobalHeader, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        this.setState({
          currentWindowWidth: window.innerWidth
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('keydown', this.handleKeyDown);
      this.handleResize();
      this.setBodyRef();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'setBodyRef',
    value: function setBodyRef() {
      /*
      * This method is used to find the closest BODY parent to the header
      * and is needed since we need to append a class to the body in order to
      * target all the elements via css to translate them when the menu is opened
      * This will work in every browser, as well as in iframes
      */
      var currentRef = this.headerRef.parentNode;
      while (!this.bodyRef && currentRef) {
        if (currentRef.tagName === 'BODY') {
          this.bodyRef = currentRef;
        } else {
          currentRef = currentRef.parentNode;
        }
      }
      this.bodyRef = this.bodyRef || document.body;
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (event.keyCode !== 27) {
        return;
      }
      if (this.state.activeLink) {
        this.closeSubnav(event);
        return;
      }
      if (this.state.isOpen) {
        this.handleMenuButton();
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize(e) {
      var _this2 = this;

      // TODO: Explore different solution to trigger resize
      // inside an iFrame; We don't need this event
      // param; it's only for page-builder
      var newWindowWidth = e && e.iFrameWidth || window.innerWidth;
      var windowWidthChanged = newWindowWidth !== this.state.currentWindowWidth;
      if (windowWidthChanged && (this.state.isOpen || this.state.activeLink)) {
        this.bodyRef.classList.remove(this.bodyClassNameWhenOpen);

        this.setState({
          isOpen: false,
          isClosing: true,
          activeLink: null,
          activeLinkIndex: -1,
          currentWindowWidth: newWindowWidth
        });
        setTimeout(function () {
          _this2.setState({
            isClosing: false
          });
        }, 400);
      }
    }
  }, {
    key: 'closeHeader',
    value: function closeHeader() {
      this.setState({
        isOpen: false,
        activeLink: null,
        activeLinkIndex: -1
      });
    }
  }, {
    key: 'openHeader',
    value: function openHeader() {
      this.setState({
        isOpen: true,
        activeLink: null,
        activeLinkIndex: -1
      });
    }
  }, {
    key: 'closeSubnav',
    value: function closeSubnav(event) {
      var _this3 = this;

      event.preventDefault();
      this.setState({
        isClosing: true,
        activeLink: null,
        closingLinkIndex: dropdownLinks.indexOf(this.state.activeLink),
        activeLinkIndex: -1
      });
      setTimeout(function () {
        _this3.setState({
          isClosing: false,
          closingLinkIndex: -1
        });
      }, 400);
    }
  }, {
    key: 'openSubnav',
    value: function openSubnav(idxOpen) {
      this.setState({
        activeLink: dropdownLinks[idxOpen],
        activeLinkIndex: idxOpen
      });
    }
  }, {
    key: 'handleMenuButton',
    value: function handleMenuButton(event) {
      var _this4 = this;

      event.preventDefault();
      if (this.state.isOpen) {
        this.bodyRef.classList.remove(this.bodyClassNameWhenOpen);
        setTimeout(function () {
          _this4.closeHeader();
        }, 350);
      } else {
        this.bodyRef.classList.add(this.bodyClassNameWhenOpen);
        this.openHeader();
      }
    }
  }, {
    key: 'handleMainLinks',
    value: function handleMainLinks(event) {
      event.preventDefault();
      var newActiveLink = this.state.activeLink !== event.currentTarget ? event.currentTarget : null;
      var newIndex = newActiveLink ? dropdownLinks.indexOf(event.target) : -1;
      if (newIndex !== -1) {
        this.openSubnav(newIndex);
      } else {
        this.closeSubnav(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var clickHandlers = {
        handleMenuButton: this.handleMenuButton,
        handleMainLinks: this.handleMainLinks,
        openHeader: this.openHeader,
        closeHeader: this.closeHeader,
        openSubnav: this.openSubnav,
        closeSubnav: this.closeSubnav
      };

      var _props = this.props,
          _props$content = _props.content,
          content = _props$content === undefined ? {} : _props$content,
          _props$config = _props.config,
          config = _props$config === undefined ? {} : _props$config;


      return _react2.default.createElement(_MPPHeaderRoot2.default, {
        className: this.props.className,
        getHeaderRef: function getHeaderRef(domNode) {
          _this5.headerRef = domNode;
        },
        content: content,
        config: config,
        menuOpen: this.state.isOpen,
        isClosing: this.state.isClosing,
        register: this.registerDropDown,
        activeLink: this.state.activeLink,
        activeLinkIndex: this.state.activeLinkIndex,
        closingLinkIndex: this.state.closingLinkIndex,
        handlers: clickHandlers,
        rtl: this.props.config.rtl
      });
    }
  }]);

  return GlobalHeader;
}(_react.Component);

GlobalHeader.propTypes = _MPPHeaderPropTypes2.default;

GlobalHeader.defaultProps = _MPPHeaderDefaultProps2.default;

exports.default = GlobalHeader;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/v1/GlobalHeader.js
// module id = 684
// module chunks = 4